import React from 'react';
import './modal_message_status.styles.css';

import PulseLoader from 'react-spinners/PulseLoader';

const StatusModal = (props) => {
  const { data, messageType } = props;

  return (
    <div className="message_status_container">
      {data.map((element, i) => {
        return (
          <div key={i} className="record-container">
            <div className="name">{`${element.text}`}</div>
            {(element[`${messageType.toLowerCase()}Status`] === 'delivered' ||
              element[`${messageType.toLowerCase()}Status`] === 'success') && (
              <div className="status">{element.message}</div>
            )}
            {(element[`${messageType.toLowerCase()}Status`] ===
              'delivery_unkown' ||
              element[`${messageType.toLowerCase()}Status`] === 'failed' ||
              element[`${messageType.toLowerCase()}Status`] === 'undelivered' ||
              element[`${messageType.toLowerCase()}Status`] === 'bounced' ||
              element[`${messageType.toLowerCase()}Status`] === 'deferred' ||
              element[`${messageType.toLowerCase()}Status`] === 'dropped') && (
              <div className="status-failed">{element.message}</div>
            )}
            {(element[`${messageType.toLowerCase()}Status`] === 'queued' ||
              element[`${messageType.toLowerCase()}Status`] === undefined ||
              element[`${messageType.toLowerCase()}Status`] === 'processed' ||
              element[`${messageType.toLowerCase()}Status`] === 'sending' ||
              element[`${messageType.toLowerCase()}Status`] === 'sent' ||
              element[`${messageType.toLowerCase()}Status`] === 'not sent') && (
              <PulseLoader
                color="red"
                loading="true"
                size={3}
                style={{ marginBottom: '5px' }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default StatusModal;
